import request from "@/utils/request";
import { TMPURL } from "./config";
import storage from "@/utils/storage";
import { initWasm, getWasmAuth, isWasmReady } from "@/utils/wasm";

//获取全局配置信息
export function apiImGetBaseInfo(params) {
  return request.post(TMPURL + "/v1/frontend/im/getBaseInfo", params);
}

//获取历史聊天信息
export function apiImGetHistoryMessage(params) {
  return request.get(TMPURL + "/v1/public/im/getHistoryMessage", params);
}

//获取IM初始化配置
export function apiImInit(params) {
  return request.get(TMPURL + "/v1/public/im/init", params);
}

//获取IM初始化配置
export function apiImTransferToService(params) {
  return request.post(TMPURL + "/v1/frontend/im/transferToService", params);
}

//初始化
export function apiKfInit(params) {
  return request.get(TMPURL + "/v1/public/kf/init", {
    ...params,
    from: sessionStorage.getItem("from") || "",
  });
}

//获取客服首页所有数据
export function apiKfIndex(params) {
  return request.get(TMPURL + "/v1/public/kf/index", params);
}

// 转人工
export function apiKfTransferToService(params) {
  return request.post(TMPURL + "/v1/frontend/im/transferToService", params);
}

// 发送消息机器人
export function apiKfSendRobotMessage(params) {
  return request.post(TMPURL + "/v1/public/robot/sendMessage", params);
}

//获取全局公告
export function getGlobalNotice(params) {
  return request.get(TMPURL + "/v1/public/notice/getGlobalNotice", params);
}

//获取IM公告
export function apiGetImNotice(params) {
  return request.post(
    TMPURL + "/v1/frontend/notice/getImNoticeHandler",
    params,
  );
}

// 有无帮助
export function apiRobotGrade(params) {
  return request.post(TMPURL + "/v1/public/robot/grade", params);
}

// 获取相似问题索引
export function apiLikeQuestion(params) {
  return request.get(TMPURL + "/v1/public/robot/questionLike", params);
}

// 夜间反馈
export function apiFeedBackNight(params) {
  return request.post(TMPURL + "/v1/frontend/im/feedBack", params, true, true);
}

// 猜你想问
export function apiGuessQuestion(params) {
  return request.get(TMPURL + "/v1/frontend/im/getPopulateQuestion", params);
}

// 获取提示语
export function apiMessageTips(params) {
  return request.get(TMPURL + "/v1/public/im/getMessageTips", params);
}

// 获取二维码
export function apiGetQrCode(params) {
  return request.get(TMPURL + "/v1/public/kf/qrCode", params, false, false);
}

// 验证消息
export function apiValidateMsg(params) {
  return request.post(TMPURL + "/v1/public/robot/validateContent", params);
}

export async function apiKfSendRobotMessageStream(msg, onMessage, onError) {
  try {
    if (!isWasmReady()) {
      await initWasm();
    }

    const bodyStr = JSON.stringify({
      ...msg,
      lang: storage.getItem("lang"),
    });

    const authData = getWasmAuth("POST", bodyStr);

    const response = await fetch(
      TMPURL + "/v1/public/robot/sendMessageStream",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: storage.getItem("token"),
          "Accept-Language": storage.getItem("lang") || "zh",
          "X-Yingxiong-Nonce": authData.nonce,
          "X-Yingxiong-Timestamp": authData.ts,
          "X-Yingxiong-Signature": authData.sign,
        },
        body: bodyStr,
        credentials: "include",
      },
    );

    if (!response.ok || !response.body) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { value, done } = await reader.read();

      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (!line.trim() || !line.startsWith("data:")) continue;

        const data = line.slice(5).trim();
        if (!data) continue;

        if (data === "[DONE]") {
          onMessage?.(null, null, null, true);
          return;
        }

        try {
          const {
            data: { answer },
          } = JSON.parse(data);
          const content = answer?.body?.content || "";
          const status = answer?.body?.status;

          if (
            answer?.body?.type === "robot" &&
            status === "switch_to_service"
          ) {
            onError?.("switch_to_service");
            return;
          }

          onMessage?.(answer, content, status);
        } catch (error) {
          console.warn("Parse error:", error);
          onError?.("parse_error");
        }
      }
    }

    // 处理缓冲区中剩余的有效数据
    if (buffer.trim() && buffer.startsWith("data:")) {
      const data = buffer.slice(5).trim();
      if (data && data !== "[DONE]") {
        try {
          const {
            data: { answer },
          } = JSON.parse(data);
          onMessage?.(
            answer,
            answer?.body?.content || "",
            answer?.body?.status,
          );
        } catch (error) {
          console.warn("Parse remaining data error:", error);
          onError?.("parse_error");
        }
      }
    }
  } catch (error) {
    console.error("Stream error:", error);
    onError?.(error.message || "connection_error");
  }
}

export async function apiUpdateAiSession(params) {
  return request.post(
    TMPURL + "/v1/public/robot/recordAiSession",
    params,
    false,
    false,
  );
}

export async function apiTalkSessionAdd(params) {
  return request.post(
    TMPURL + "/v1/public/talkSession/add",
    params,
    false,
    false,
  );
}

export async function apiGetTalkSessionHistory(params) {
  return request.post(
    TMPURL + "/v1/public/talkSession/historyPageList",
    params,
    false,
    false,
  );
}

export async function apiSendAiMsg(params) {
  return request.post(
    TMPURL + "/v1/public/talkSession/aiAnswer",
    params,
    false,
    false,
  );
}
